export const NO_ITEMS = 0

export const BETWEEN_CARDS_SPACING = 0.5
